import Vue from 'vue';
import store from "@/store";

export default {
    post: (payload) => {
        return Vue.axios.post(`/api/${store.state.tenantId}/userEmails`, payload)
            .then(resp => resp.data);
    },
};